export default __webpack_public_path__ + "static/media/courier_mob.7788ac50.png";